import { Model as r } from "../../../model.js";
class o extends r {
  constructor(e) {
    super(), this.paid = e.paid, this.earned = e.earned;
  }
}
export {
  o as TicketCashbackModel
};
//# sourceMappingURL=ticketCashback.model.js.map
